import { Component, Input } from '@angular/core';
import { InternationalInsuranceVehicleTypeEnum } from '@app/my-zone/enums';
import { PurchasedProductInterface } from 'outshared-lib';
import { IntersectionObserverService } from '@app/core/services/intersection-observer.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'ins-insurance-imic-caravan',
    templateUrl: './insurance-imic-caravan.component.html',
})
export class InsuranceIMICCaravanComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    public internationalInsuranceVehicleTypeEnum = InternationalInsuranceVehicleTypeEnum;
    public isScreenSmall$: Observable<boolean> = this.intersectionObserverService.isScreenSmall$;
    public showCaravanPanel: boolean;

    constructor(public intersectionObserverService: IntersectionObserverService) {
    }
}
